export default __webpack_public_path__ + "static/media/amazon-scene.fea14ddf.webp";